import React from 'react'
import { Switch, useHistory, useLocation, useRouteMatch, Route } from 'react-router-dom'
import { Layout as LayoutAntd, Menu, Row, Col, Divider, Avatar, Drawer, Dropdown } from 'antd'
import Icon, { MenuUnfoldOutlined, MenuFoldOutlined, CaretDownOutlined } from '@ant-design/icons'
import { useLocalStore, observer } from 'mobx-react-lite'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import logo_header from './assets/images/logo_header.png'
import styled from 'styled-components'
import { SourceRoute, configAuthRouteUser, configNoticeMenu, pathNames } from './routers/router'
import { removeSessionStorage, keyNameSessionStorage, getSessionStorage } from './utils/sessionStorage'
import { ReactComponent as IconProfileSVG } from './assets/svg/ic_profile.svg'
import useStore from './stores/useStore'
import PrivateRouteUser from './routers/PrivateRouteUser'
import PrivateRouteAdmin from './routers/PrivateRouteAdmin'
import { Badge } from 'antd'
import jwt from 'jsonwebtoken'
import { removeCmsToken, removeSelfToken } from './utils/cookie'
import { goToWebCms, goToWebBi } from './routers/apiAuth'
// import { toJS } from 'mobx'

import usePortal from './hooks/usePortal'

const { Header, Content } = LayoutAntd

const StyledBadge = styled(Badge)({
    padding: 10,
})

type UseLayoutProps = {}
type ReturnTypeHooks = ReturnType<typeof useLayout>
const useLayout = (props: UseLayoutProps) => {
    const { notificationMenuStore, userStore, questionnaireStore } = useStore()
    const history = useHistory()
    const { goToWebBase } = usePortal()

    const location = useLocation()

    const match = useRouteMatch({
        path: location.pathname,
    })
    const breakpoint = useBreakpoint()

    const infoProfile = JSON.parse(getSessionStorage(keyNameSessionStorage.user) as string)
    const accessToken = getSessionStorage(keyNameSessionStorage.accessToken) || ''

    const jwtDecoded = jwt.decode(accessToken, { complete: true }) as {
        payload?: {
            exp?: number
            roles?: string[]
        }
    }

    const state = useLocalStore(() => ({
        collapsed: false,
        onToggleCollapse() {
            this.collapsed = !this.collapsed
        },
        onOpenCollapse() {
            this.collapsed = true
        },
        onCloseCollapse() {
            this.collapsed = false
        },
    }))

    const systemMenu = userStore?.profileInfo?.accessMenus ?? []
    const systemMenuList = systemMenu.filter((item) => item.systemID !== 1)

    const switchGoto = (id: number) => {
        switch (id) {
            case 2:
                return goToWebCms
            case 3:
                return goToWebBase
            case 5:
                return goToWebBi

            default:
                return () => {}
        }
    }

    const manageMenu = () => {
        if (systemMenuList.length > 0) {
            return systemMenuList.map((item) => {
                return {
                    ...item,
                    systemNameTH: item.systemID === 2 ? `${item.systemNameTH} (CMS)` : `${item.systemNameTH}`,
                    goto: switchGoto(item.systemID),
                }
            })
        } else {
            return [
                {
                    systemID: 3,
                    systemNameTH: 'ระบบจัดการฐานข้อมูล',
                    systemNameEN: 'Web Base',
                    goto: switchGoto(3),
                    functions: [],
                },
            ]
        }
    }

    return {
        jwtDecoded,
        state,
        history,
        location,
        match,
        breakpoint,
        notificationMenu: notificationMenuStore.notificationMenu,
        infoProfile: infoProfile,
        systemList: manageMenu(),
        questionnaireStore,
        goToWebBase,
    }
}

export const StyledSystemName = styled.span`
    width: 133px;
    height: 15px;
    text-align: right;
    letter-spacing: 0.2px;
    color: #093018;
    opacity: 1;
    font-size: 10px;
`
const StyledMenu = styled(Col)<{ $selected?: boolean }>(({ $selected }) => {
    let styledSelected = {}
    if ($selected) {
        styledSelected = {
            height: 86,
            lineHeight: '86px',
            marginTop: -8,
            marginBottom: -10,
            // height: 56,
            // lineHeight: '56px',
            // marginTop: -8,
            // marginBottom: -8,
            backgroundColor: '#80BD01',
            color: '#F9F9F9',
            paddingLeft: 15,
            paddingRight: 20,
        } as React.CSSProperties
    }
    return {
        height: 70,
        lineHeight: '70px',

        // height: 40,
        // lineHeight: '40px',
        cursor: 'pointer',
        ...styledSelected,
    }
})
const StyledDividerMenu = styled(Divider)<{ $selected?: boolean }>(({ $selected }) => {
    let styledSelected = {}
    if ($selected) {
        styledSelected = {
            visibility: 'hidden',
        } as React.CSSProperties
    }
    return {
        '&.ant-divider-vertical': {
            top: '1.7em',
            // top: '0.5em',
            height: '1.6em',
        },
        ...styledSelected,
    }
})

type LayoutViewProps = { routes: SourceRoute[] } & ReturnTypeHooks
let LayoutView: React.FC<LayoutViewProps> = ({
    routes,
    state,
    history,
    location,
    match,
    breakpoint,
    children,
    infoProfile,
    notificationMenu,
    jwtDecoded,
    systemList,
    questionnaireStore,
}) => {
    const isDesktop = breakpoint.md

    const isIPadHoriz = !breakpoint.lg && breakpoint.sm && breakpoint.md
    const isIPadVertical = breakpoint.lg && breakpoint.sm && breakpoint.md && !breakpoint.xl

    const renderDropdown = () => {
        return (
            <>
                <Dropdown
                    overlay={
                        <Menu>
                            {systemList.map((item, index) => (
                                <Menu.Item key={index} onClick={async () => item.goto()}>
                                    {item.systemNameTH}
                                </Menu.Item>
                            ))}

                            <Menu.Item
                                key={99}
                                onClick={() => {
                                    //@ts-ignore
                                    if (jwtDecoded?.payload?.roles?.[0] === 'ADMIN') {
                                        removeSessionStorage([
                                            keyNameSessionStorage.user,
                                            keyNameSessionStorage.accessToken,
                                            keyNameSessionStorage.refreshToken,
                                        ])

                                        removeSelfToken()
                                        removeCmsToken()
                                        window.location.href = process.env.REACT_APP_PORTAL as string
                                    } else if (jwtDecoded?.payload?.roles?.[0] === 'USER') {
                                        removeSessionStorage([
                                            keyNameSessionStorage.user,
                                            keyNameSessionStorage.accessToken,
                                            keyNameSessionStorage.refreshToken,
                                        ])

                                        removeSelfToken()
                                        removeCmsToken()
                                        window.location.href = process.env.PUBLIC_URL + pathNames.signIn
                                    } else {
                                        window.location.href = process.env.PUBLIC_URL + pathNames.signIn
                                    }
                                }}
                            >
                                ออกจากระบบ
                            </Menu.Item>
                        </Menu>
                    }
                    placement='bottomCenter'
                    // trigger={['click']}
                >
                    <CaretDownOutlined css={{ cursor: 'pointer' }} />
                </Dropdown>
            </>
        )
    }

    return (
        <LayoutAntd css={{ minWidth: '100%', minHeight: '100%' }}>
            <Header
                css={{
                    backgroundColor: '#FFFFFF',
                    // backgroundColor: '#fff',
                    boxShadow: '0px 30px 30px #80BD010A',
                    padding: '8px 28px 8px 28px',
                    position: 'sticky',
                    zIndex: 20,
                    top: 0,
                    lineHeight: 'initial',
                    height: 'auto',
                    left: '17px',
                    width: 'calc(100% - 34px)',
                }}
            >
                <Row gutter={[28, 0]} align={isDesktop ? undefined : 'middle'}>
                    {isDesktop ? (
                        <>
                            <Col md={4} lg={4} xl={8}>
                                <img
                                    src={logo_header}
                                    alt='Logo'
                                    style={{
                                        marginTop: 15,
                                    }}
                                />
                                <StyledSystemName css={{ display: 'block', marginTop: 2, textAlign: 'left' }}>
                                    {/* SELF-ASSESSMENT SYSTEM */}
                                    ระบบ CBT Thailand
                                </StyledSystemName>
                            </Col>
                            <Col
                                md={isIPadHoriz ? 16 : 12}
                                lg={isIPadHoriz ? 16 : 12}
                                xl={10}
                                css={{
                                    alignSelf: 'center',
                                    marginLeft: 'auto',
                                }}
                                style={{
                                    display: 'grid',
                                    justifyContent: isIPadHoriz || isIPadVertical ? 'center' : 'start',
                                    left: '10px',
                                }}
                            >
                                <Row>
                                    {routes.map((route) => {
                                        const isNoticeMenu = configNoticeMenu.some((item) => item.path === route.path)
                                        const noticeMenu = notificationMenu.find((item) => isNoticeMenu)
                                        const selected = match?.path.startsWith(route.path)

                                        return (
                                            <React.Fragment key={route.path}>
                                                <StyledMenu
                                                    style={{
                                                        paddingRight: 20,
                                                        paddingLeft: 20,
                                                    }}
                                                    title={state.collapsed ? undefined : route.title}
                                                    onClick={async () => {
                                                        await route.onBeforeChangePath?.()
                                                        questionnaireStore.resetQuestionnaire()
                                                        if (location.pathname === route.path) {
                                                            history.replace(route.path)
                                                        } else {
                                                            history.push(route.path)
                                                        }
                                                    }}
                                                    $selected={selected}
                                                >
                                                    {isNoticeMenu ? (
                                                        <StyledBadge
                                                            count={noticeMenu?.countBadge ?? 0}
                                                            css={{
                                                                color: selected
                                                                    ? '#F9F9F9 !important'
                                                                    : '#000000D9 !important',
                                                            }}
                                                            overflowCount={999}
                                                        >
                                                            {route.title}
                                                        </StyledBadge>
                                                    ) : (
                                                        route.title
                                                    )}
                                                </StyledMenu>
                                                <StyledDividerMenu
                                                    type='vertical'
                                                    $selected={selected}
                                                    css={{
                                                        margin: 0,
                                                    }}
                                                />
                                            </React.Fragment>
                                        )
                                    })}
                                </Row>
                            </Col>
                        </>
                    ) : (
                        React.createElement(state.collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
                            onClick: state.onOpenCollapse,
                        })
                    )}

                    <Col
                        md={isIPadHoriz ? 3 : 8}
                        lg={isIPadHoriz ? 3 : 8}
                        xl={6}
                        css={{
                            alignSelf: 'center',
                            marginLeft: 'auto',
                        }}
                    >
                        <Row gutter={[8, 0]} style={{ justifyContent: isIPadHoriz ? 'center' : 'end' }}>
                            <Col>
                                {infoProfile?.imageUrl ? (
                                    <Avatar src={infoProfile.imageUrl || ''} />
                                ) : (
                                    <Icon component={IconProfileSVG} css={{ fontSize: 32 }} />
                                )}
                            </Col>
                            <Col>
                                <div style={{ fontSize: 'xx-small' }}>
                                    ยินดีต้อนรับ {isIPadHoriz && renderDropdown()}
                                </div>
                                {!isIPadHoriz && (
                                    <div style={{ color: '#000000', fontWeight: 'bold' }}>
                                        <>{`${infoProfile?.firstName ? infoProfile?.firstName + ' ' : ''}${
                                            infoProfile?.lastName || ''
                                        }`}</>

                                        {renderDropdown()}
                                    </div>
                                )}
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Header>

            {!isDesktop && (
                <Drawer
                    placement='left'
                    title={
                        <Col>
                            <img src={logo_header} alt='Logo' />
                            <StyledSystemName css={{ display: 'block', marginTop: 2, textAlign: 'left' }}>
                                {/* SELF-ASSESSMENT SYSTEM */}
                                ระบบ CBT Thailand
                            </StyledSystemName>
                        </Col>
                    }
                    closable={false}
                    onClose={state.onCloseCollapse}
                    visible={state.collapsed}
                    width={183}
                    bodyStyle={{ padding: 0 }}
                >
                    <Menu
                        theme='light'
                        mode='inline'
                        selectedKeys={
                            match?.path ? ['/' + match.path.split('/')[1] + '/' + match.path.split('/')[2]] : undefined
                        }
                    >
                        {routes.map((route) => (
                            <Menu.Item
                                key={route.path}
                                title={state.collapsed ? undefined : route.title}
                                onClick={async () => {
                                    await route.onBeforeChangePath?.()

                                    state.onCloseCollapse()
                                    if (location.pathname === route.path) {
                                        history.replace(route.path)
                                    } else {
                                        history.push(route.path)
                                    }
                                }}
                            >
                                {route.title}
                            </Menu.Item>
                        ))}
                    </Menu>
                </Drawer>
            )}
            <Content
                css={{
                    backgroundColor: 'transparent',
                    // backgroundColor: '#fff',
                    // margin: isDesktop ? '24px 16px' : '16px 8px',
                    // padding: isDesktop ? 24 : 16,
                }}
            >
                <Switch>
                    <Route path={configAuthRouteUser?.map((item) => item.path) || []} component={PrivateRouteUser} />
                    {routes.length && (
                        <Route
                            path={routes
                                ?.flatMap((router) => [router, ...(router.routes || [])])
                                .map((route) => route.path)}
                            render={(props) => {
                                return (
                                    <>
                                        <PrivateRouteAdmin
                                            {...props}
                                            //@ts-ignore
                                            routes={routes?.flatMap((router) => [router, ...(router.routes || [])])}
                                        />
                                    </>
                                )
                            }}
                        />
                    )}
                </Switch>
            </Content>
        </LayoutAntd>
    )
}
LayoutView = observer(LayoutView)

type LayoutProps = UseLayoutProps & Omit<LayoutViewProps, keyof ReturnTypeHooks>
let Layout: React.FC<LayoutProps> = ({ ...others }) => {
    const layout = useLayout({})
    return <LayoutView {...layout} {...others} />
}
Layout = observer(Layout)

export default Layout
